import { useState, useEffect } from 'react';
import { useApi } from '../hooks/useApi';

// FunÃ§Ã£o que verifica se o estabelecimento estÃ¡ aberto
const checkStoreStatus = () => {
  const now = new Date();
  const currentHour = now.getHours();
  
  // Verifica se o horÃ¡rio Ã© antes das 18:00
  console.log(currentHour);  
  return currentHour >= 18;
};

// Hook customizado para verificar e gerenciar o estado de abertura da loja
export const useStoreStatus = () => {
  const [isStoreOpen, setIsStoreOpen] = useState();
  const [msgStorageClose, setMsgStorageClose] = useState();
  const [horariosFuncionamento, setHorariosFuncionamento] = useState([]);
  const { fetchData } = useApi();

  const refreshStoreStatus = async () => {
    try {
      // Buscar status correto
      const status = await fetchData('/HorarioFuncionamento/status');

      setIsStoreOpen(status.aberto);

      if (!status.aberto) {
        setMsgStorageClose(status.motivo || 'Estabelecimento fechado!');
      } else {
        setMsgStorageClose(status.motivo);
      }

      // Buscar horÃ¡rios padrÃ£o
      const horarios = await fetchData('/HorarioFuncionamento/todosHorarios');
      setHorariosFuncionamento(horarios);

      return status;
    } catch (error) {
      console.error("Erro ao buscar status/horÃ¡rios:", error);
      throw error;
    }
  };

  // useEffect(() => {
  //   const status = checkStoreStatus();
  //   setIsStoreOpen(status);

    
    
  //   if (isStoreOpen) {
  //       setMsgStorageClose(null);
  //   } else {
  //       setMsgStorageClose('Estabelecimento fechado. Abrimos somente apÃ³s as 18:00.');
  //   }
  // }, [isStoreOpen]);

  useEffect(() => {
    refreshStoreStatus().catch(() => {});
  }, []);


  return { isStoreOpen, msgStorageClose, horariosFuncionamento, refreshStoreStatus };
};
